import { LoadState } from "../../constants/enums";

export interface IMyRenewalsState {
  list: IMyRenewals[];
  loading: LoadState;
  generatedPremiumReportList: IGeneratedPremiumReport[];
  generatedPremiumReportLoading: LoadState;
}

export interface IGeneratedPremiumReport {
  premium_report_id: string | null;
  report_log_code: string | null;
  policy_id: string | null;
  customer_name: string | null;
  premium_code: string | null;
  customer_code: string | null;
  customer_id: string | null;
  policy_number: string | null;
  agency_bill_or_direct_bill: string | null;
  producer_one_code: string | null;
  branch_code: string | null;
  insurer: string | null;
  effective_date: string | null;
  expiry_date: string | null;
  line_of_business: string | null;
  policy_type: string | null;
  existing_year: string | null;
  existing_premium: string | null;
  new_year: string | null;
  new_premium: string | null;
  premium_difference: string | null;
  percent_change: string | null;
  created_by_id: string | null;
  modified_by_id: string | null;
  created_by_name: string | null;
  modified_by_name: string | null;
  status: string | null;
  assign_id: string | null;
}
export interface IMyRenewals {
  report_log_code: string | null;
  creation_date: string | null;
  result_length: string | null;
  comment: string | null;
  status: string | null;
  created_by_id: string | null;
  created_by_name: string | null;
  modified_by_id: 1;
  modified_by_name: string | null;
  create_ts: string | null;
}



export const initialMyRenewalsState: IMyRenewalsState = {
  list: [],
  loading: LoadState.NotLoaded,
  generatedPremiumReportList: [],
  generatedPremiumReportLoading: LoadState.NotLoaded,
};
